import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ArtifactRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { useTranslation } from "react-i18next";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: ArtifactRegionTileFragment;
  paginationArtifactAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function ArtifactRegionTile({
  fragment,
  paginationArtifactAttributeId,
  children,
  dispatch,
}: Props) {
  const { t } = useTranslation();

  const paginationArtifactAttribute = fragment.attributes.find(
    (a) => a.id === paginationArtifactAttributeId,
  );
  assertTypeName(
    paginationArtifactAttribute?.__typename === "PaginationArtifactAttribute",
  );

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      onClick={onClick}
      preview={t(
        `ArtifactRegionTile.preview.${paginationArtifactAttribute.type}`,
      )}
    >
      {children}
    </RegionTile>
  );
}
